import * as React from "react"
import MainLayout from "../components/MainLayout"

const Ssm2016Page = () => {
  return (
    <MainLayout>
      <h1>SSM 2016</h1>
      <p>2016 var första året som Säkerhets-SM anordnades. Tävlingen arrangerades då av föreningen <a href="https://ungvetenskapssport.se/">Ung Vetenskapssport</a>. <a href="/2016/">Här</a> är en länk till hur hemsidan såg ut då.</p>
      <h2>Arrangörsgrupp</h2>
      <ul>
        <li>Johan Sannemo</li>
        <li>Ludvig Janiuk</li>
        <li><a href="https://zeta-two.com/">Calle "Zeta Two" Svensson</a></li>
        <li>Simon Lindholm</li>
      </ul>
    </MainLayout>
  )
}

export default Ssm2016Page
